import { createFileRoute, redirect } from '@tanstack/react-router'

import { ExistingAccount } from '@/containers/ExistingAccount'
import { existingAccountSearchSchema } from '@/lib/searchSchemas/checkExistingAccount'
import { detectExistingAccountQueryOptions } from '@/queries/registration/registration'

export const Route = createFileRoute(
  '/_unauthenticated/setup/check-existing-account'
)({
  validateSearch: existingAccountSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({
    context: { orgStore, queryClient },
    deps: { track_id, email },
  }) => {
    const existingAccount = await queryClient.ensureQueryData(
      detectExistingAccountQueryOptions({
        org_id: orgStore.getState().orgId,
        track_id,
      })
    )
    if (!existingAccount?.linked_orgs?.length) {
      redirect({
        to: '/setup/password-creation',
        state: state => ({
          ...state,
          email,
          track_id,
        }),
        throw: true,
      })
    }
  },
  component: ExistingAccount,
})
